import React, {
  useDebugValue,
  useEffect,
  useInsertionEffect,
  useState,
} from "react";
import "./style.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getFilterList } from "../action";

const FilterModal = (props) => {
  const {
    filterList,
    addFilter,
    removeFilter,
    setOpenFilterModal,
    getFilterList,
    eCart,
  } = props;

  let SCHEME_FILTERS = {
    FUND_CATEGORY: {
      id: "1",
    },
    TIME_HORIZON: {
      id: "2",
    },
    GOALS: {
      id: "3",
    },
    RISK_RATING: {
      id: "4",
    },
  };
  const [allFilterList, setAllFilterList] = useState(null);
  const [openFilter, setOpenFilter] = useState({
    [SCHEME_FILTERS.FUND_CATEGORY.id]: true,
    [SCHEME_FILTERS.TIME_HORIZON.id]: true,
    [SCHEME_FILTERS.GOALS.id]: true,
    [SCHEME_FILTERS.RISK_RATING.id]: true,
  });

  const onload = async () => {
    let response = await getFilterList();
  };

  useEffect(() => {
    onload();
  }, []);

  useEffect(() => {
    if (eCart?.filterList?.apiLoaded) {
      setAllFilterList(eCart?.filterList?.data);
    }
  }, [eCart.filterList]);

  if (allFilterList) {
    SCHEME_FILTERS = {
      FUND_CATEGORY: {
        id: "1",
        name: "Fund Category",
        list: allFilterList && allFilterList["fundCategories"],
      },
      TIME_HORIZON: {
        id: "2",
        name: "Time Horizon",
        list: allFilterList && allFilterList["timeHorizons"],
      },
      GOALS: {
        id: "3",
        name: "Goals",
        list: allFilterList && allFilterList["goalTypes"],
      },
      RISK_RATING: {
        id: "4",
        name: "Risk Rating",
        list: allFilterList && allFilterList["riskRatings"],
      },
    };
  }

  const openCloseFilter = (id) => {
    setOpenFilter((prev) => {
      return {
        ...prev,
        [id]: !prev[id],
      };
    });
  };

  const onFilterSelect = (event) => {
    let { checked: isChecked, id: filterId, value: filterValue } = event.target;
    if (isChecked) addFilter(filterId, filterValue);
    else removeFilter(filterId, filterValue);
  };

  return (
    <>
      <div className="filter-modal-overlay" />
      
        <div className="filter-modal">
        <div className="filterM">
          <h4 className="title">
            Filters
            <button
              className="close"
              onClick={() => setOpenFilterModal(false)}
            ></button>
          </h4>
          {Object.keys(SCHEME_FILTERS).map((key, index) => {
            const item = SCHEME_FILTERS[key];
            return (
              <div className="filter" key={item.id}>
                <div
                  className="filter-title"
                  onClick={() => openCloseFilter(item.id, index)}
                >
                  <h4>{item.name}</h4>
                </div>
                {openFilter[item.id] && (
                  <ul className="list">
                    {item && item.list && item.list.map((ele, index) => {
                      const isChecked = filterList[item.id].includes(ele);
                      return (
                        <li className="filter-name" key={index}>
                          <input
                            type="checkbox"
                            id={item.id}
                            value={ele}
                            onClick={onFilterSelect}
                            checked={isChecked}
                          ></input>
                          <label>{ele}</label>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            );
          })}

        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  eCart: state.eCart,
});

const mapDispatchToProps = (dispatch) => ({
  getFilterList: bindActionCreators(getFilterList, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterModal);
